import React, { useState } from "react";
import { Grid, Link } from "@material-ui/core/";
import Button from "@material-ui/core/Button";
import "./about.css";
import * as data from "../performance-tracker-template/data-toload.json";
import { Gauge } from "../visualisations/gauge";
import { Sunburst } from "../visualisations/sunburst";
import { BarChart } from "../visualisations/barchart";
import { useHistory } from "react-router-dom";
import gcc_banner from "../img/gcc_banner.png";
import img_legend_v from "../img/legend_2.png";
import icon_sust_energy from "../img/env_energy.png";
interface IProps {
  organisation: string
}
export const ReportingPage: React.FC<IProps> = (props: IProps) => {
  const [diagramImage, setDiagramImage] = useState<string>("");
  const [gaugeDiagramImage, setGaugeDiagramImage] = useState<string>("");
  const history = useHistory();
  const dataStyles: { [tab: string]: EnvTempStyles } = data.envTemplateStyles;
  var quants = [
    {
      "Sustainable Energy & Carbon Reduction": [
        {
          "Carbon Reduction Planning & Delivery": [
            {
              index: 1,
              question: "Carbon Management Plan",
              score: 3,
              maximumScore: 5,
            },
            {
              index: 2,
              question: "Delivery team",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 3,
              question: "Publishing strategy",
              score: 0.5,
              maximumScore: 1,
            },
          ],
        },
        {
          "Energy Efficiency Measures": [
            {
              index: 4,
              question: "Low carbon heating",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 5,
              question: "LED lighting",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 6,
              question: "Heat & ventilation",
              score: 1.8,
              maximumScore: 2,
            },
            {
              index: 7,
              question: "Building fabric",
              score: 2,
              maximumScore: 3,
            },
            {
              index: 8,
              question: "Insulation of buildings",
              score: 0,
              maximumScore: 1,
            },
            {
              index: 9,
              question: "Natural lighting",
              score: 1,
              maximumScore: 1,
            },
          ],
        },
        {
          "Production In Fossil Fuel Consumption": [
            {
              index: 10,
              question: "PV",
              score: 2.8,
              maximumScore: 5,
            },
            {
              index: 11,
              question: "Energy Provision from renewables",
              score: 1,
              maximumScore: 5,
            },
            {
              index: 12,
              question: "Carbon emissions from energy consumption",
              score: 1.5,
              maximumScore: 5,
            },
          ],
        },
      ],
    },
    {
      "CLEAN AIR": [
        {
          "Electrical Charge Points": [
            {
              index: 13,
              question: "Ratio of electrical vehicle (EV) charge points",
              score: 2,
              maximumScore: 2,
            },
          ],
        },
        {
          "Schemess to Incentivise & Disincentivise": [
            {
              index: 14,
              question: "Incentive schemes",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 15,
              question: " Disincentivizing schemes",
              score: 0,
              maximumScore: 1,
            },
            {
              index: 16,
              question: "Eco-safe driver training",
              score: 0,
              maximumScore: 0.5,
            },
          ],
        },
        {
          "Encourage Low Emission Vehicles": [
            {
              index: 17,
              question: "Ultra–low emission concentration (commuting fleet)",
              score: 0.1,
              maximumScore: 1,
            },
            {
              index: 18,
              question:
                "Ultra–low emission concentration (goods and services fleet)",
              score: 0.6,
              maximumScore: 2,
            },
          ],
        },
      ],
    },
    {
      ENVIRONMENT: [
        {
          "Establishing Green Infrastructure": [
            {
              index: 19,
              question: "Quality of biodiverse external environments",
              score: 0,
              maximumScore: 1,
            },
            {
              index: 20,
              question: "Green infrastructure management",
              score: 1,
              maximumScore: 1,
            },
            {
              index: 21,
              question: "Tree planting",
              score: 1,
              maximumScore: 1,
            },
          ],
        },
        {
          "Support % Management of Green Infrastructure": [
            {
              index: 22,
              question: "Green wall/roof project",
              score: 1,
              maximumScore: 2,
            },
            {
              index: 23,
              question: "Connectivity with green corridor",
              score: 1,
              maximumScore: 1,
            },
          ],
        },
      ],
    },
    {
      "WASTE & WATER MANAGEMENT": [
        {
          "Adoption of sustainable waste models": [
            {
              index: 24,
              question: "Waste segregation",
              score: 3,
              maximumScore: 3,
            },
            {
              index: 25,
              question: "Waste stream auditing",
              score: 1,
              maximumScore: 3,
            },
            {
              index: 26,
              question: "Waste management training",
              score: 0,
              maximumScore: 2,
            },
          ],
        },
        {
          "Plastic Management and Procurement Strategies": [
            {
              index: 27,
              question: "Elimination of single–use plastic",
              score: 0,
              maximumScore: 1,
            },
            {
              index: 28,
              question: "Sustainable procurement strategy",
              score: 0,
              maximumScore: 3,
            },
          ],
        },
        {
          "Water consumption controls": [
            {
              index: 29,
              question: "Deployment of water–saving measures",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 30,
              question: "Water consumption and leakage monitoring",
              score: 3,
              maximumScore: 3,
            },
            {
              index: 31,
              question: "Water efficiency training",
              score: 0,
              maximumScore: 1,
            },
          ],
        },
      ],
    },
    {
      "SUSTAINABLE TRAVEL": [
        {
          "Enhance Adoption of Active and Public Modes of Travel": [
            {
              index: 32,
              question:
                "Ratio of employees walking, cycling & working from home",
              score: 1,
              maximumScore: 5,
            },
            {
              index: 33,
              question: "Ratio of employees using public transport",
              score: 0.2,
              maximumScore: 3,
            },
            {
              index: 34,
              question: "Low emission transport facilities",
              score: 2,
              maximumScore: 2,
            },
            {
              index: 35,
              question: "Car sharing scheme",
              score: 0.3,
              maximumScore: 1,
            },
          ],
        },
        {
          "Supporting Smart Travel": [
            {
              index: 36,
              question: "Travel plan",
              score: 0,
              maximumScore: 2,
            },
            {
              index: 37,
              question: "Method of transport for business trips",
              score: 1.5,
              maximumScore: 2,
            },
            {
              index: 38,
              question: "Flight avoidance",
              score: 1,
              maximumScore: 1,
            },
            {
              index: 39,
              question: "Journey optimisation",
              score: 1.5,
              maximumScore: 2,
            },
          ],
        },
      ],
    },
  ];
  var questionStyles = {
    "Sustainable Energy & Carbon Reduction": {
      themeBackground: "#c14c4a",
      subThemeBackground: "#e99889",
      themeItemBackground: "",
      color: "",
      img: "",
    },
    "CLEAN AIR": {
      themeBackground: "#198df1",
      subThemeBackground: "#83daff",
      themeItemBackground: "",
      color: "",
      img: "",
    },
    ENVIRONMENT: {
      themeBackground: "#3d9732",
      subThemeBackground: "#8dd380",
      themeItemBackground: "",
      color: "",
      img: "",
    },
    "WASTE & WATER MANAGEMENT": {
      themeBackground: "#5c5446",
      subThemeBackground: "#b39a5b",
      themeItemBackground: "",
      color: "",
      img: "",
    },
    "SUSTAINABLE TRAVEL": {
      themeBackground: "#c7ac37",
      subThemeBackground: "#fcd743",
      themeItemBackground: "",
      color: "",
      img: "",
    },
  };
  var placeHolders = {
    "Sparse Measures": {
      lowerLimit: 0,
      upperLimit: 30,
      style: {
        themeBackground: "#ec697a",
        subThemeBackground: "#e99889",
        themeItemBackground: "",
        color: "",
        img: "",
      },
    },
    "Scope For Improvement": {
      lowerLimit: 30,
      upperLimit: 50,
      style: {
        themeBackground: "#fcca00",
        subThemeBackground: "#fcca00",
        themeItemBackground: "",
        color: "",
        img: "",
      },
    },
    Satisfactory: {
      lowerLimit: 50,
      upperLimit: 70,
      style: {
        themeBackground: "#a8d28b",
        subThemeBackground: "#a8d28b",
        themeItemBackground: "",
        color: "",
        img: "",
      },
    },
    Good: {
      lowerLimit: 70,
      upperLimit: 90,
      style: {
        themeBackground: "#b4c701",
        subThemeBackground: "#b4c701",
        themeItemBackground: "",
        color: "",
        img: "",
      },
    },
    Outstanding: {
      lowerLimit: 90,
      upperLimit: 100,
      style: {
        themeBackground: "#538330",
        subThemeBackground: "#538330",
        themeItemBackground: "",
        color: "",
        img: "",
      },
    },
  };

  //iterating through every subcategory to create barcharts
  var barCharts = [];
  for (var i = 0; i < quants.length; i++) {
    //going through every category
    var nameOfCategory = Object.keys(quants[i])[0];
    var allSubCategories = Object.values(quants[i])[0];
    for (var j = 0; j < allSubCategories.length; j++) {
      var nameOfSubCategory = Object.keys(allSubCategories[j])[0];
      var subCategoryObject = Object.values(allSubCategories[j])[0];
      var object = {
        [nameOfCategory]: [
          {
            [nameOfSubCategory]: subCategoryObject,
          },
        ],
      };
      var barchartProps = {
        questionResults: object,
        questionStyles: questionStyles,
      };
      barCharts.push(barchartProps);
    }
  }

  var gaugeProps = {
    year: 2020,
    value: 55,
    sections: placeHolders,
  };

  var sunburstProps = {
    questionResults: quants,
    questionStyles: questionStyles,
    sections: placeHolders,
  };

  return (
    <div>
      <h2>Green City Charter Reports Comparison</h2>
      <Grid container spacing={9}>
        <Grid item lg={6} md={12}>
          <div className="reporting_box">
            <div className="report_box_title">
              <span>Environment report</span>
            </div>
            <div className="request_report">
              <Link href="mailto:p.a.d.turner@soton.ac.uk">request a report</Link>
            </div>
            <div>
              <img
                src={gcc_banner}
                style={{ width: "100%", margin: "10px auto" }}
              />
            </div>
            <Grid
              container
              justify="space-between"
              style={{ marginBottom: 20 }}
            >
              {Object.keys(dataStyles).map((tabName: string) => {
                return (
                  <Grid
                    item
                    xs={2}
                    style={{
                      background: dataStyles[tabName].themeBackground,
                      textAlign: "center",
                      color: "white",
                      borderBottomStyle: "solid",
                    }}
                    key={tabName}
                    onClick={() => {
                      window.open("/guide.pdf");
                    }}
                  >
                    <img
                      src={dataStyles[tabName].img}
                      style={{ width: "100%" }}
                    />
                    <div style={{ fontSize: 10}}>
                      {tabName}
                    </div>
                  </Grid>
                );
              })}
            </Grid>
            <Grid container spacing={3} justify="space-evenly">
              <Grid item xs={6}>
                <div style={{ height: "90%", border: "red 1px solid" }}>
                  <div
                    style={{
                      height: 150,
                      overflow: "hidden",
                    }}
                  >
                    <div style={{ zoom: 0.4 }}>
                      {gaugeDiagramImage === "" ? (
                        "loading gauge"
                      ) : (
                        <img src={gaugeDiagramImage} />
                      )}
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={6}>
                <div className="reporting_text_1">
                  The Southampton Green City (GC) Performance measures a
                  signatory’s commitments and progress against a common set of
                  agreed assessment criteria. This Tracker not only allows a
                  signatory to assess its performance against these criteria but
                  allows organisations to identify pathways to reaching
                  sustainable targets.
                </div>
              </Grid>
            </Grid>
            <div className="reporting_text_1">
              The Green City (GC) assessment was carried out on {props.organisation + " "}
              based on data supplied by {props.organisation}. As of June 2021,
              {" " + props.organisation + " "} has achieved a GC score of 55%, giving an
              overall score of Satisfactory scoring the following
              <ul>
                <li>Sustainable Energy & Carbon Reduction – Satisfactory 64%</li>
                <li>Clean Air – Scope For Improvement 40%</li>
                <li>Natural Environment – Good 70%</li>
                <li>Resource, Waste & Water Management – Scope For Improvement 41%</li>
                <li>Sustainable Travel – Satisfactory 50%</li>
              </ul>
              These scores as well as those for the sub-themes are given in
              Figure 2. With a full breakdown of the numerical scores given in
              Table 1.
            </div>
            <Grid container spacing={2} justify="space-between">
              <Grid item xs={7}>
                <div>
                  {diagramImage === "" ? (
                    "loading diagram"
                  ) : (
                    <img src={diagramImage} width="100%" />
                  )}
                </div>
              </Grid>
              <Grid item xs={5}>
                <img src={img_legend_v} style={{ width: "100%" }} />
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item lg={6} md={12}>
          <div className="reporting_box">
            <div className="report_box_title">
              <span>Carbon emissions report</span>
            </div>
            <div className="request_report">
              <Link href="mailto:p.a.d.turner@soton.ac.uk">request a report</Link>
            </div>
            {/* <div style={{ padding: 20 }}>
              {barCharts.map((chart, i) => {
                return <BarChart key={i} data={chart}></BarChart>;
              })}
            </div> */}
            <div
              style={{
                margin: "auto",
                width: 200,
                height: 200,
                padding: 20,
                border: "black 1px solid",
              }}
            >
              To be finished
            </div>
          </div>
        </Grid>
      </Grid>
      {gaugeDiagramImage === "" ? (
        <div style={{ height: "500px", width: "500px" }}>
          <Gauge
            data={gaugeProps}
            setDiagramImage={setGaugeDiagramImage}
            imageReturn={true}
          ></Gauge>
        </div>
      ) : null}
      {diagramImage === "" ? (
        <div style={{ height: "500px", width: "500px" }}>
          <Sunburst
            data={sunburstProps}
            setDiagramImage={setDiagramImage}
            imageReturn={true}
          ></Sunburst>
        </div>
      ) : null}
    </div>
  );
};
